// @ts-strict

import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { IConversationsState } from '@app/core/models/core-models';

/**
 * @ngModule CoreModule
 * @description
 *
 * Service responsible for sharing current conversation panel view variant between components
 */
@Injectable({
  providedIn: 'root'
})
export class MinimizeMaximizeConversationsService {
  public state: IConversationsState = {
    minimized: false,
    maximized: false
  };
  public currentView = new Subject<IConversationsState>();

  constructor() {}

  public minimize(): void {
    this.state.minimized = true;
    this.state.maximized = false;
    this.currentView.next(this.state);
  }

  public maximize(): void {
    this.state.minimized = false;
    this.state.maximized = true;
    this.currentView.next(this.state);
  }

  public close(): void {
    this.state.maximized = false;
    this.state.minimized = false;
    this.currentView.next(this.state);
  }

  public returnView(): IConversationsState {
    return this.state;
  }
}
